var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPinA(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 36,
    viewBox: "0 0 32 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#ca4539;}.c{opacity:0;}.d{fill:#707070;}.e{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 3,
    y: 0,
    width: 26,
    height: 36,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#002445",
    floodOpacity: 0.302
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-145 -5244)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(152.824 5248.283)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "e",
    transform: "matrix(1, 0, 0, 1, -7.82, -4.28)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.452,24.184h9.1A53.465,53.465,0,0,1,10,30,53.531,53.531,0,0,1,5.452,24.184Zm0,0C2.811,20.291,0,15.024,0,10.17A10.086,10.086,0,0,1,10,0,10.087,10.087,0,0,1,20,10.17c0,4.854-2.81,10.121-5.452,14.014Z",
    transform: "translate(6 3)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M5.111,22.673h8.527a50.123,50.123,0,0,1-4.264,5.452A50.185,50.185,0,0,1,5.111,22.673Zm0,0C2.636,19.023,0,14.085,0,9.534A9.456,9.456,0,0,1,9.375,0,9.457,9.457,0,0,1,18.75,9.534c0,4.55-2.634,9.488-5.111,13.138Z",
    transform: "translate(-1.199 -0.658)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(3.176 3.717)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 32,
    height: 32,
    transform: "translate(177 5278) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1,1V31H31V1H1M0,0H32V32H0Z",
    transform: "translate(177 5278) rotate(180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPinA);
export default __webpack_public_path__ + "static/media/icon_pin_a.7e10bed798fd30f95e5ef71f6e3b489b.svg";
export { ForwardRef as ReactComponent };